import { useTranslation } from '@/i18n';
import classNames from 'classnames';
import { FC, PropsWithChildren, memo } from 'react';
import styles from './RequiredHeader.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  noPadding?: boolean;
};

export const RequiredHeader: FC<PropsWithChildren<Props>> = memo(
  ({ noPadding, children }) => {
    const { t } = useTranslation();
    return (
      <div className={cx(styles['container'])}>
        <div
          className={cx(styles['content'], noPadding && styles['no-padding'])}
        >
          {children}
          <span className={cx(styles['required'])}>{t('required_label')}</span>
        </div>
      </div>
    );
  }
);
RequiredHeader.displayName = 'RequiredHeader';
